import {
  getDocs, collection, query, orderBy, where,
} from 'firebase/firestore';
import { db } from '@/config/firebase';

export default async function fetchAllOrders() {
  try {
    const ref = collection(db, 'requests');
    const q = query(
      ref,
      orderBy('createdAt', 'desc'),
      // where('inputData', '!=', ''),
      where('serviceId', '==', 'SsVwQ9ZoMNKc1XOrMdCo'),
    );
    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (err) {
    console.error('[fetchAllOrders]', err);
    throw err;
  }
}
